import { apiClient } from "./apiClient";

import type {
  CreateTagInput,
  DeleteTagData,
  TagDetailsData,
  TagItemData,
  TagsListData,
  TagsQuery,
  UpdateTagInput,
} from "../types/tags.types";

function buildTagsQuery(
  query: TagsQuery = {},
): string {
  const params = new URLSearchParams();

  if (query.search?.trim()) {
    params.set(
      "search",
      query.search.trim(),
    );
  }

  if (query.isActive !== undefined) {
    params.set(
      "isActive",
      String(query.isActive),
    );
  }

  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }

  if (query.cursor?.trim()) {
    params.set(
      "cursor",
      query.cursor.trim(),
    );
  }

  if (query.limit !== undefined) {
    params.set(
      "limit",
      String(query.limit),
    );
  }

  const queryString = params.toString();

  return queryString
    ? `/tags?${queryString}`
    : "/tags";
}

export const tagsApi = {
  list(query: TagsQuery = {}) {
    return apiClient.get<TagsListData>(
      buildTagsQuery(query),
    );
  },

  getById(tagId: string) {
    return apiClient.get<TagDetailsData>(
      `/tags/${encodeURIComponent(tagId)}`,
    );
  },

  create(input: CreateTagInput) {
    return apiClient.post<TagItemData>(
      "/tags",
      input,
    );
  },

  update(
    tagId: string,
    input: UpdateTagInput,
  ) {
    return apiClient.patch<TagItemData>(
      `/tags/${encodeURIComponent(tagId)}`,
      input,
    );
  },

  delete(tagId: string) {
    return apiClient.delete<DeleteTagData>(
      `/tags/${encodeURIComponent(tagId)}`,
    );
  },
};